import API from "../config/api.js";

export const GLAccountService = {

  list(filters, page = 1) {
    return API.get("/api/ledger/gl-accounts", { params: { filters, page } });
  },
  update(id, data) {
    return API.put(`/api/ledger/gl-accounts/${id}`, data);
  },
  getAccountTypes() {
    return API.get("/api/ledger/gl-accounts/types");
  },
  getTrialBalance() {
    return API.get(`/api/gl-accounts/trial-balance`);
  }
}
